
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/channels/[slugChannel]",
      function () {
        return require("private-next-pages/channels/[slugChannel]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/channels/[slugChannel]"])
      });
    }
  